/* eslint-disable no-console */

import { ENVIRONMENTS } from 'constants/environments';
import DataDogLogs from 'utils/DataDogLogs';
import Settings from 'utils/Settings';

const UnifiedLogger = class {
  constructor(loggerType) {
    this.type = loggerType;
  }

  static get loggingIsEnabled() {
    return (
      Settings.environment === ENVIRONMENTS.STAGING ||
      Settings.environment === ENVIRONMENTS.DEVELOPMENT
    );
  }

  error = (message, context = null, error = null) => {
    const logMessage = this.type ? `type=${this.type} | ${message}` : message;
    DataDogLogs.error(logMessage, context, error);
    console.error(logMessage, error, context);
  };

  warn = (message, context = null, error = null) => {
    const logMessage = this.type ? `type=${this.type} | ${message}` : message;
    DataDogLogs.warn(logMessage, context, error);
    console.warn(logMessage, error, context);
  };

  info = (message, context = null, error = null) => {
    const logMessage = this.type ? `type=${this.type} | ${message}` : message;
    DataDogLogs.info(logMessage, context, error);
    if (UnifiedLogger.loggingIsEnabled) {
      console.debug(logMessage, error, context);
    }
  };

  debug = (...args) => {
    if (UnifiedLogger.loggingIsEnabled) {
      console.debug(...args);
    }
  };
};

export default UnifiedLogger;
